import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ApiServices } from '../../services/api.service';
import { DataService } from '../../services/data.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-search-by-size',
  templateUrl: './search-by-size.component.html',
  styleUrls: ['./search-by-size.component.css']
})
export class SearchBySizeComponent implements OnInit {

  isLoading = false;

  searchSizeForm: FormGroup;
  formDropdownValues: any;
  showRearSizeFields = false;

  showFirstIcon = true;

  constructor( private apiService: ApiServices, private formService: FormService, private dataService: DataService, private router: Router, private route: ActivatedRoute, public helperService: HelperService) {
    //
    this.searchSizeForm = this.formService.sizeSearchForm();
    this.getSearchSizeParams();
  }

  ngOnInit(): void {
    this.getSearchSizeParams();
  }


  getSearchSizeParams(): void {
    this.apiService.searchSizeParams().subscribe(
      next => {
        this.formDropdownValues = next.data;
      }, error => {
        console.log('error', error);
      }
    );
  }

    onAddRearOptions = (rear: boolean) => {
    if (rear) {
      this.searchSizeForm.controls.rear_rim_diameter.setValidators([Validators.required]);
      this.searchSizeForm.controls.rear_rim_diameter.updateValueAndValidity();
      this.searchSizeForm.controls.rear_rim_width.setValidators([Validators.required]);
      this.searchSizeForm.controls.rear_rim_width.updateValueAndValidity();
      this.searchSizeForm.controls.rear_min_offset.setValidators([Validators.required]);
      this.searchSizeForm.controls.rear_min_offset.updateValueAndValidity();
      this.searchSizeForm.controls.rear_max_offset.setValidators([Validators.required]);
      this.searchSizeForm.controls.rear_max_offset.updateValueAndValidity();
      
    } else {
      this.searchSizeForm.controls.rear_rim_diameter.clearValidators();
      this.searchSizeForm.controls.rear_rim_diameter.updateValueAndValidity();
      this.searchSizeForm.controls.rear_rim_width.clearValidators();
      this.searchSizeForm.controls.rear_rim_width.updateValueAndValidity();
      
      this.searchSizeForm.controls.rear_min_offset.clearValidators();
      this.searchSizeForm.controls.rear_min_offset.updateValueAndValidity();
      this.searchSizeForm.controls.rear_max_offset.clearValidators();
      this.searchSizeForm.controls.rear_max_offset.updateValueAndValidity();


    }
  }

  onSubmitSizeSearchForm = () => {
    if (this.searchSizeForm.valid) {

      $('.close').click();
      
      const queryParams = new URLSearchParams({
        ...this.searchSizeForm.value,
        offset: `${this.searchSizeForm.value.min_offset}to${this.searchSizeForm.value.max_offset}`,
        ...(this.searchSizeForm.value.rear_min_offset && this.searchSizeForm.value.rear_max_offset && {
          rear_offset: `${this.searchSizeForm.value.rear_min_offset}to${this.searchSizeForm.value.rear_max_offset}`
        })
      }).toString();
      
      location.href = `/search-by-size?${queryParams}`;
      
    } else {
      this.searchSizeForm.markAllAsTouched();
    }
  }

  toggleIcon() {
    this.showFirstIcon = !this.showFirstIcon;
  }


}
